import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
    CanActivate,
    ActivatedRouteSnapshot,
    RouterStateSnapshot,
    CanActivateChild,
    UrlTree,
    ActivatedRoute,
    Router
} from '@angular/router';
import { Observable } from 'rxjs';
import { UserService } from '../services/user.service';
import { ProviderStateService } from '../services/provider-state.service';
ProviderStateService

@Injectable({
    providedIn: 'root'
})
export class AuthPatientGuard implements CanActivate, CanActivateChild {
    slug: string = "";
    constructor(
        private readonly user: UserService,
        private readonly router: Router,
        private readonly activatedRoute: ActivatedRoute,
        private readonly providerstateService: ProviderStateService
    ) {
        this.providerstateService.getProviderSlug();
    }
    canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        return new Observable<boolean>((obs) => {
            this.user
                .UserCheck(sessionStorage.getItem('userid'))
                .subscribe((result) => {
                    obs.next(true);
                });
        });
    }
    canActivateChild(next: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        return new Observable<boolean>((obs) => {
            this.user
                .UserCheck(sessionStorage.getItem('userid'))
                .subscribe((result) => {
                    obs.next(true);
                });
        });
    }


    async DoctorGuard(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): Promise<boolean | UrlTree> {
        return await this.user
            .UserCheck(sessionStorage.getItem('userid'))
            .toPromise()
            .then((result) => {
                if (result.success) {
                    return true;
                }
                else {
                    this.router.navigate(['/' + this.slug + "/accessdenied"], { relativeTo: this.activatedRoute });
                    return false;
                }

            }).catch((error: HttpErrorResponse) => {
                // let redirectTo = route.pathFromRoot
                //   .filter(p => p !== route && p.url !== null && p.url.length > 0)
                //   .reduce((arr, p) => arr.concat(p.url.map(u => u.path)), new Array<string>());
                // this.router.navigate(redirectTo.concat("dashboard"), { relativeTo: this.activatedRoute });
                this.router.navigate(['/' + this.slug + "/accessdenied"], { relativeTo: this.activatedRoute });
                return false;
            });
    }
}
